import { useCallback, useEffect, useRef, useState } from 'react';
import debounce from 'lodash-es/debounce';
import useInputValue from './UseInputValue';
const InputStoppedChangingBeforeValidateMs = 500;
export default function useStringValueInputHandlers(props, validation) {
    const isMounted = useRef(false);
    const [value, setValue, initialValue] = useInputValue(props, '');
    const [isFocused, setIsFocused] = useState(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const validate = useCallback((e) => {
        if (isMounted.current) {
            validation?.validate(e.target.value);
        }
    }, [validation]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedValidate = useCallback(debounce(validate, InputStoppedChangingBeforeValidateMs), [validate]);
    // This is a separate once-off useEffect to ensure validation is run when the component is rendered
    const isFirstTime = useRef(true);
    useEffect(() => {
        if (isFirstTime.current && initialValue) {
            validation?.validate(value);
            isFirstTime.current = false;
        }
    }, [initialValue, validation, value]);
    const handleChange = (e) => {
        setValue(e.target.value);
        props?.onChange?.(e.target.value);
        // Here we debounce the validation if its their first time using the input (ux nicety to let them stop typing before throwing a validation message)
        const validationNeverBeenRun = props && validation?.isValid === undefined;
        if (validationNeverBeenRun) {
            debouncedValidate(e);
        }
        else {
            validate(e);
        }
    };
    const handleBlur = () => {
        props?.onBlur?.(value);
        validation?.validate(value);
        setIsFocused(false);
    };
    const handleKeyDown = (e) => {
        props?.onKeyDown?.(e);
        if (e.key === 'Enter') {
            if (value) {
                props?.onEnterPressed?.(value);
            }
        }
    };
    const handleFocus = (e) => {
        setIsFocused(true);
        props?.onFocus?.(e);
    };
    return {
        handleBlur,
        handleChange,
        handleKeyDown,
        handleFocus,
        value,
        setValue,
        isFocused,
        setIsFocused,
    };
}
//# sourceMappingURL=UseStringValueInputHandlers.js.map